<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    // this.disableViewSource();
  },
  methods: {
    disableViewSource() {
      $(document).keydown(function (event) {
        if (event.keyCode == 123) { // Prevent F12
          return false;
        } else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) { // Prevent Ctrl+Shift+I
          return false;
        }
      });
      $(document).on("contextmenu", function (e) {
        e.preventDefault();
      });
    }
  }
}
</script>

<style lang="scss">
/* Import Font Awesome Icons Set */
$fa-font-path: '~font-awesome/fonts/';
@import '~font-awesome/scss/font-awesome.scss';
// Import Main styles for this application
@import 'src/assets/scss/style';
</style>
